package one.healthium.log_food.ui.scanner.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.log_food.ui.scanner.BarcodeScannerScreen

@Composable
fun BarcodeScannerContent(component: BarcodeScannerComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        BarcodeScannerScreen(component)
    }
}